/**
 * Renders its children only if the operator holds the permission.
 *
 * For hiding a control rather than disabling it — a Delete button a planner
 * can never use is noise, not a hint. Where the control should stay visible
 * but inert (so its absence is not mistaken for a bug), use `usePermission`
 * and pass `disabled` instead.
 *
 * Mirrors famtrak's <Authorized>.
 */
import type { ReactNode } from 'react';

import type { Permission } from './permissions';
import { usePermission } from './usePermission';

interface AuthorizedProps {
  children: ReactNode;
  /** Holding any one of these is enough. */
  permission: Permission | readonly Permission[];
  /** Shown instead when the operator does not hold it. Usually nothing. */
  fallback?: ReactNode;
}

export function Authorized({ children, permission, fallback = null }: AuthorizedProps) {
  return usePermission(permission) ? <>{children}</> : <>{fallback}</>;
}
